import { ReactElement } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Carousel } from 'src/components/carousel/carousel';
import { WORK_SEARCH } from 'src/constants/routes';

import { ReactComponent as EventLinkIcon } from 'src/assets/event-arrow.svg';
import { useResize } from 'src/hooks/shared-hooks';
import Vacancy from 'src/pages/job-search/vacancy';
import { VacancyModel } from 'src/types';
import { fireEvent } from 'src/utils/analytics/google';
import css from './vacancies.module.scss';

export default function GeneralVacancies({ items, title }: Readonly<{ items: VacancyModel[]; title?: JSX.Element }>) {
  const navigate = useNavigate();
  const dimensions = useResize();
  const desktopMode = dimensions.width > 1000;
  const mobileMode = dimensions.width < 500;

  const showItems = () => {
    if (items.length >= 4 && desktopMode) {
      return 2;
    } else {
      return !desktopMode ? 1 : items.length;
    }
  };

  function handleVacancyClick(vacancy: VacancyModel) {
    fireEvent('view_vacancy', {
      title: vacancy.name,
      url: vacancy.slug
    });
    navigate(`/work/work-search/vacancy/${vacancy.slug}`);
  }

  function groupArrayInPairs(arr: ReactElement[]) {
    const result = [];
    for (let i = 0; i < arr.length; i += 2) {
      result.push(
        <div key={arr[i].key} className={css.carouselCard}>
          {arr.slice(i, i + 2)}
        </div>
      );
    }
    return result;
  }

  const contentItems = items?.map((v: VacancyModel) => (
    <Vacancy key={v?.id} vacancy={v} onClick={() => handleVacancyClick(v)} />
  ));

  if (contentItems.length === 0) return null;

  return (
    <div className={css.vacancies}>
      <Carousel
        data={mobileMode ? contentItems : groupArrayInPairs(contentItems)}
        title={
          title ?? (
            <div className={css.header}>
              <Link to={WORK_SEARCH.path}>
                <p> Всі вакансії</p> <EventLinkIcon />
              </Link>
              <h3>Вакансії ЦВС</h3>
            </div>
          )
        }
        itemsToShow={showItems()}
      />
    </div>
  );
}
